import type { Route } from '@application/types';
import { useRouter } from '@application/utils';
import { ActionsPopper, Footer } from '@presentation/components';
import { useMemo } from 'react';
import { useFormatFooter } from './api/useFormatFooter';
import { useFormatInternalLinks } from './api/useFormatInternalLinks';
import { useGetInternalLinks } from './api/useGetInternalLinks';
import { useLocaleSwitcher } from './useLocaleSwitcher';

export const FOOTER_INTERNAL_LINKS_ROUTES: Route[] = [
  'breeder',
  'litter',
  'breed',
  'breederList',
  'litterList',
];

export const FooterController = () => {
  const { infoFromCurrentPath } = useRouter();
  const localeSwitcher = useLocaleSwitcher();
  const { categories, rows } = useFormatFooter(localeSwitcher);

  const skipInternalLinks = useMemo(() => {
    return !FOOTER_INTERNAL_LINKS_ROUTES.includes(infoFromCurrentPath.route);
  }, [infoFromCurrentPath.route]);

  const { breeds } = useGetInternalLinks(skipInternalLinks);
  const { internalLinks } = useFormatInternalLinks(breeds);

  return (
    <>
      <Footer categories={categories} rows={rows} internalLinks={internalLinks} />
      <ActionsPopper {...localeSwitcher.popperProps} />
    </>
  );
};
